module.exports = __webpack_public_path__ + "static/media/best.2fb328d5.png";